import { makeRequest } from 'utils/requestLogger';

export default (participationID, observations) =>
  makeRequest(
    'put',
    `/api/participations/${participationID}/add_observations`,
    { observations }
  );



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/observations.js